const SITUATION = {
  title: 'Situation comptable',
  breadcrumb: {
    racine: 'Accueil',
    situation: 'Situation comptable',
  },
  actions: {
    actualiser: 'Actualiser le calcul',
  },
  filtres: {
    periodeComptable: 'Période comptable du / au',
    dateSituation: 'Date de situation',
    agence: 'Agence',
  },
  messages: {
    success: {
      calculDone: 'Le calcul a été actualisé avec succès',
    },
    error: {
      exportExcel: 'La période comptable et la date de situation doivent être renseignées pour pouvoir faire un export',
    },
  },
  error: {
    mustHaveDateOrExercice: 'Vous devez saisir une période pour faire le calcul',
    mustHaveDate: 'Vous devez saisir une date de début et de fin pour la période',
  },
  tab: {
    depense: 'Dépenses',
    recette: 'Recettes',
    tva: 'TVA %',
    supportCommercial: 'Support commercial',
    factureNonParvenues: 'Factures non parvenues',
    chargeConstate: 'Charges constatées d\'avance',
    factureEmettre: 'Factures à émettre',
    produitConstate: 'Produits constatés d\'avance',
    totalTva: 'Total {TauxTva}%',
    total: 'Total',
    noRslt: 'Aucun résultat',
  },
};

export default SITUATION;
